<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Work Order Process" active>

                                <b-row v-if="hasFailedDataWorkOrderProcess">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedWorkOrderProcess.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="workOrderProcesssFailed" :fields="fieldsWorkOrderProcess" :busy="isDataLoading"
                                                         :sort-by.sync="sortByWorkOrderProcess" :sort-desc.sync="sortDescWorkOrderProcess" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(productionDate)="row">
													{{ row.item.productionDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedWorkOrderProcess.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="workOrderProcesss" :fields="fieldsWorkOrderProcess" :busy="isDataLoading"
                                                         :sort-by.sync="sortByWorkOrderProcess" :sort-desc.sync="sortDescWorkOrderProcess" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(productionDate)="row">
													{{ row.item.productionDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Work Order Process Detail" active>

                                <b-row v-if="hasFailedDataWorkOrderProcessDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedWorkOrderProcessDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="workOrderProcessDetailsFailed" :fields="fieldsWorkOrderProcessDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByWorkOrderProcessDetail" :sort-desc.sync="sortDescWorkOrderProcessDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyPlan)="row">
													{{ Number(row.item.qtyPlan).toLocaleString() }}
												</template>
												<template #cell(hourPlan)="row">
													{{ Number(row.item.hourPlan).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedWorkOrderProcessDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="workOrderProcessDetails" :fields="fieldsWorkOrderProcessDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByWorkOrderProcessDetail" :sort-desc.sync="sortDescWorkOrderProcessDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyPlan)="row">
													{{ Number(row.item.qtyPlan).toLocaleString() }}
												</template>
												<template #cell(hourPlan)="row">
													{{ Number(row.item.hourPlan).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import WorkOrderProcess from '@/models/WorkOrderProcess/WorkOrderProcess';
import WorkOrderProcessList from '@/models/WorkOrderProcess/WorkOrderProcessList';
import WorkOrderProcessFilter from '@/filters/WorkOrderProcess/WorkOrderProcessFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsWorkOrderProcess: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Production Date", key: 'productionDate', sortable: false},
				{"class" : "th-status", "label" : "Line Code", key: 'lineCodeCode', sortable: false},
				{"class" : "th-status", "label" : "Process Type", key: 'processTypeCode', sortable: false},
				{"class" : "th-status", "label" : "Document Status", key: 'documentStatusName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsWorkOrderProcessDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Part Number", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Bill Of Process", key: 'billOfProcessPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Line Machine", key: 'machineCode', sortable: false},
				{"class" : "th-status", "label" : "Qty (Plan)", key: 'qtyPlan', sortable: false},
				{"class" : "th-status", "label" : "Hour (Plan)", key: 'hourPlan', sortable: false},
				{"class" : "th-status", "label" : "Remark", key: 'remark', sortable: false},
				{"class" : "th-status", "label" : "Document Status", key: 'documentStatusName', sortable: false},
				{"class" : "th-status", "label" : "LotNo", key: 'lotNo', sortable: false},
				{"class" : "th-status", "label" : "Is Reference", key: 'isReference', sortable: false},
				{"class" : "th-status", "label" : "Is Print Label", key: 'isPrintLabel', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			workOrderProcesss : [],
			workOrderProcesssFailed: [],
			workOrderProcessId : '',
			sortByWorkOrderProcess: '',
			sortDescWorkOrderProcess: '',
			hasFailedDataWorkOrderProcess: false,
			totalFailedWorkOrderProcess: 0,
			totalSucceedWorkOrderProcess: 0,
			workOrderProcessDetails : [],
			workOrderProcessDetailsFailed: [],
			workOrderProcessDetailId : '',
			sortByWorkOrderProcessDetail: '',
			sortDescWorkOrderProcessDetail: '',
			hasFailedDataWorkOrderProcessDetail: false,
			totalFailedWorkOrderProcessDetail: 0,
			totalSucceedWorkOrderProcessDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('workorderprocess/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('workorderprocess/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getWorkOrderProcessForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getWorkOrderProcessForUpload : async function() {
			let _this = this;
			this.$http.get('workorderprocess/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.workOrderProcesss = [];
_this.workOrderProcessDetails = [];


					if (response != null) {
						let result = response.data;
						_this.workOrderProcesss = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedWorkOrderProcess = _this.workOrderProcesss.length;

						_this.workOrderProcesssFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataWorkOrderProcess = true;
						_this.totalFailedWorkOrderProcess = 0;
						if(_this.workOrderProcesssFailed == undefined || _this.workOrderProcesssFailed.length === 0) _this.hasFailedDataWorkOrderProcess = false;
						if(_this.hasFailedDataWorkOrderProcess) _this.totalFailedWorkOrderProcess = _this.workOrderProcesssFailed.length;
						_this.workOrderProcessDetails = [];
						_this.workOrderProcessDetailsFailed = [];
						_this.hasFailedDataWorkOrderProcessDetail = true;
						_this.totalSucceedWorkOrderProcessDetail = 0;
						result.forEach(function(element) {
							_this.workOrderProcessDetails.push(...element.workOrderProcessDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedWorkOrderProcessDetail = _this.workOrderProcessDetails.length;

							_this.workOrderProcessDetailsFailed.push(...element.workOrderProcessDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.workOrderProcessDetailsFailed == undefined || _this.workOrderProcessDetailsFailed.length === 0) _this.hasFailedDataWorkOrderProcessDetail = false;
							if(_this.hasFailedDataWorkOrderProcessDetail) _this.totalFailedWorkOrderProcessDetail = _this.workOrderProcessDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'workorderprocess/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'WorkOrderProcess.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterWorkOrderProcess = new WorkOrderProcessFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
